import { render, staticRenderFns } from "./imgDialog.vue?vue&type=template&id=f570906a&scoped=true"
import script from "./imgDialog.vue?vue&type=script&lang=js"
export * from "./imgDialog.vue?vue&type=script&lang=js"
import style0 from "./imgDialog.vue?vue&type=style&index=0&id=f570906a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f570906a",
  null
  
)

export default component.exports